import styled from 'styled-components';
import tw from 'twin.macro';

export const SidebarContainer = styled.div`
  width: ${(props) => (props.on ? '440px' : 'fit-content')};
  min-width: ${(props) => (props.on ? '440px' : 'fit-content')};
  position: relative;

  .toggle-btn {
    display: ${(props) => (props.on ? 'none' : 'flex')};
    position: absolute;
    border-radius: 10px;
    width: 40px;
    height: 40px;
    right: ${(props) => (props.on ? '-20px' : '-30px')};
    top: 50%;
    transform: translateY(-50%);
    // box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    font-size: 24px;
    align-items: center;
    justify-content: center;
    color: #fff;

    .callout {
      display: none;
      bottom: -30px;
      position: absolute;
      background: rgba(0, 0, 0, 0.7);
      padding: 2px 8px;
      font-size: 14px;
      border-radius: 6px;
      z-index: 1111;
    }

    &:hover {
      background: #2a84cb;
      color: white;

      .callout {
        display: block;
      }
    }
    &:focus {
      outline: none;
    }
  }

  &:hover {
    .toggle-btn {
      display: flex;
    }
  }

  .lesson-list {
    overflow: auto;

    .selected {
      ${tw`bg-primary text-white rounded-lg`}

      background-color: ${(props) => props.bg};
      svg > path {
        stroke: white;
      }
    }

    .lesson-title {
      width: calc(100% - 36px);
      font-size: 12px;
      font-weight: 500;
    }
    .check-circle {
      min-width: 16px;
      min-height: 16px;
    }
  }
`;
export const TitleContainer = styled.div`
  background-color: ${(props) => props.bg};
  border-radius: 15px;
  .progress-bar {
    width: 79px;
    min-width: 79px;
    height: 79px;
    position: relative;

    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 41px;
      height: ${(props) => (props.isIcsc ? '41px' : '31px')};
    }
  }
`;
export const ContentSelector = styled.div`
  border-radius: 15px;
`;
export const ContentTitleContainer = styled.div`
  min-height: 72px;
  padding: 40px;
  padding-bottom: 20px;
`;
export const LinkButton = styled.div.attrs({
  className: 'hover:underline cursor-pointer font-bold uppercase text-sm',
})`
  display: flex;
  align-items: center;
`;
export const Container = styled.div`
  max-width: 1440px;
  .complete-btn {
    min-width: 120px;
    width: 140px;
    padding: 7px 13px;
    font-size: 14px;
    font-weight: 500;
    height: 26px;
    line-height: 14px;
  }
`;
